export default __webpack_public_path__ + "static/media/banner.2007f9f5.png";